import React, { memo } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { Nav4DragAndDropMenuItemProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { Nav4RoadmapsWithRecent } from './Nav4RoadmapsWithRecent.tsx';
import type { Nav4Roadmaps_query$key } from './__generated__/Nav4Roadmaps_query.graphql.ts';

export type Nav4RoadmapsProps = Nav4DragAndDropMenuItemProps & {
	isExpanded: boolean;
	queryRef: Nav4Roadmaps_query$key;
};

export const Nav4Roadmaps: React.FC<Nav4RoadmapsProps> = memo((props: Nav4RoadmapsProps) => {
	const { queryRef, ...rest } = props;

	const dataQuery = useFragment<Nav4Roadmaps_query$key>(
		graphql`
			fragment Nav4Roadmaps_query on Query @argumentDefinitions(currentURL: { type: "URL" }) {
				...Nav4RoadmapsWithRecent_query @arguments(currentURL: $currentURL)
			}
		`,
		// Needs to be done in all navigations for navx-global-side-nav to work
		// eslint-disable-next-line @atlassian/relay/use-fragment-naming
		queryRef,
	);

	return <Nav4RoadmapsWithRecent {...rest} queryRefFragment={dataQuery} />;
});
